const idCardRegexp = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
const DNumber = /^\d+$/
const phoneRegexp = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
const trueNameReg = /^[\u4E00-\u9FA5]{2,5}$/
const punctuationRegex = /[，、。！？：；]/

// 判断文本是否包含，、。！？：；
export function findPunctuationIndex(text: string) {
    const match = text.match(punctuationRegex)
    return match ? text.indexOf(match[0]) : -1
}

// 替换文本中出现的指定标签对
export function findPuncSpanCon(text: string) {
    const result = text.replace(/<p>|<\/p>|<li>|<\/li>|<ul>|<\/ul>|<ol>|<\/ol>/g, "")
    return result
}

// 验证身份证号
export const useIDCardNumber = (data: string) => {
    return idCardRegexp.test(data)
}

// 验证年龄
export const useAge = (data: string) => {
    return DNumber.test(data)
}

// 验证手机号
export const usePhone = (data: string) => {
    return phoneRegexp.test(data)
}

// 验证真实姓名
export const useTrueName = (data: string) => {
    return trueNameReg.test(data)
}